import { render, staticRenderFns } from "./ProductAutocomplete.vue?vue&type=template&id=087990d4"
import script from "./ProductAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./ProductAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports